import React, { useState } from "react";
import {
  Box,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  Input,
  HStack,
  Spinner,
  Center,
  Text,
  useToast,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { useAdminVendors, Vendor } from "api/admin";

export default function Vendors(): JSX.Element {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  
  const { data, isLoading, isError } = useAdminVendors({ page, limit: 10, search, role: 'vendor' });

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card p="20px" mb="20px">
        <HStack mb="20px" spacing={4}>
          <Input placeholder="Search vendors" value={search} onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setSearch(e.target.value)} />
        </HStack>

        {isLoading ? (
          <Center p="40px"><Spinner /></Center>
        ) : isError ? (
          <Center p="40px"><Text color="red.500">Failed to load data.</Text></Center>
        ) : !data?.data?.length ? (
          <Center p="40px"><Text>No data found.</Text></Center>
        ) : (
          <Box overflowX="auto">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Email</Th>
                  <Th>Properties</Th>
                  <Th>Wallet Balance</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data?.data?.map((v: Vendor) => (
                  <Tr key={v.id}>
                    <Td>{v.fullName}</Td>
                    <Td>{v.email}</Td>
                    <Td>{v._count?.locations || 0}</Td>
                    <Td>₦{(v.wallet?.balance || 0).toLocaleString()}</Td>
                    <Td>
                      <Badge colorScheme={v.deactivated ? "red" : "green"}>
                        {v.deactivated ? "Deactivated" : "Active"}
                      </Badge>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            <Flex justify="space-between" mt="4">
              <Button disabled={page === 1} onClick={() => setPage(p => p - 1)}>Prev</Button>
              <Text>Page {data?.page} of {(data?.totalPage || 0)}</Text>
              <Button disabled={page >= (data?.totalPage || 0)} onClick={() => setPage(p => p + 1)}>Next</Button>
            </Flex>
          </Box>
        )}
      </Card>
    </Box>
  );
}
